export default __webpack_public_path__ + "static/media/impacto_banner_2020.5a6d96fe.png";